/* Progressive enhancement: every menu also works with native details alone. */
if (!customElements.get('dsv-home-menu')) {
  customElements.define('dsv-home-menu', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      const menus = [...this.querySelectorAll('.dsvm-dropdown')];
      const timers = new Map();
      const clear = menu => { clearTimeout(timers.get(menu)); timers.delete(menu); };
      const close = (except = null) => menus.forEach(menu => { clear(menu); if (menu !== except) menu.open = false; });
      this.close = close;
      const revealFinder = () => {
        const finder = document.getElementById('dsv-game-finder');
        const details = finder?.matches('details') ? finder : finder?.querySelector('details');
        if (!details) return;
        details.open = true;
        details.querySelector('summary')?.focus({ preventScroll: true });
      };
      const revealFinderFromHash = () => {
        if (location.hash === '#dsv-game-finder') revealFinder();
      };
      // Also open the finder when arriving from a product or collection page.
      window.addEventListener('hashchange', revealFinderFromHash, opts);
      if (document.readyState === 'complete') revealFinderFromHash();
      else document.addEventListener('DOMContentLoaded', revealFinderFromHash, { ...opts, once: true });
      menus.forEach(menu => {
        menu.addEventListener('toggle', () => { if (menu.open) close(menu); }, opts);
        menu.addEventListener('pointerenter', event => {
          clear(menu);
          if (event.pointerType === 'mouse' && matchMedia('(hover:hover) and (min-width:1001px)').matches) {
            timers.set(menu, setTimeout(() => { close(menu); menu.open = true; }, 120));
          }
        }, opts);
        menu.addEventListener('pointerleave', event => {
          clear(menu);
          if (event.pointerType === 'mouse' && !menu.contains(document.activeElement)) timers.set(menu, setTimeout(() => { menu.open = false; }, 200));
        }, opts);
        menu.addEventListener('focusout', event => {
          if (event.relatedTarget && !menu.contains(event.relatedTarget)) { clear(menu); menu.open = false; }
        }, opts);
        menu.addEventListener('keydown', event => {
          if (event.key === 'Escape' && menu.open) {
            event.preventDefault(); event.stopPropagation(); close();
            menu.querySelector('summary').focus();
          }
        }, opts);
      });
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) close(); }, opts);
      document.addEventListener('click', event => {
        const link = event.target.closest('[data-dsv-menu-finder]');
        if (!link) return;
        close();
        link.closest('.dsv-mobile-navigation')?.removeAttribute('open');
        revealFinder();
      }, opts);
      window.addEventListener('resize', () => { if (matchMedia('(max-width:1000px)').matches) close(); }, opts);
    }
    disconnectedCallback() { this.close?.(); this.abort?.abort(); }
  });
}
